import { ReactElement, useEffect, useState } from "react";
import Dirs from "../fmanlibs/Dirs";
import { FMFile } from "../shared/FMFile";
import FManApi from "../fmanlibs/FManApi";
import { useSnackbar } from "../libs/dialog/SnackbarProvider";
import TextContent from "./TextContent";
import Loading from "../libs/loading/Loading";
import { IconButton } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { useDialog } from "../libs/dialog/DialogProvider";
import ImageContent from "./ImageContent";

export default function PreviewDlg(props:{file:FMFile}) {
    const {file} = props
    const [content,setContent] = useState<string|null>(null)
    const [url,setUrl] = useState<string|null>(null)
    const parent = Dirs.i.findNode(file.parentId!)
    const filename = (parent?.path||"")+"/"+file.name
    const {setSnackbar} = useSnackbar()
    const {closeDialog} = useDialog()
    
    let preview :ReactElement|null = null
    if (content!==null) preview = <TextContent text={content}/>
    else if (url!==null) preview = <ImageContent url={url}/>
    else preview = <Loading className="mt-32"/>

    useEffect(() => {
        if (FMFile.isText(file)) FManApi.i.getContent(file._id).then(content => setContent(content)).catch(e => setSnackbar(e))
        else FManApi.i.shareFiles([file._id], 1).then(url => setUrl(url)).catch(e => setSnackbar(e))
    }, [])
    return <>
        <div className="header flex middle between">{filename} <IconButton size="small" onClick={closeDialog}><CloseOutlined/></IconButton></div>
        <div className="content">{preview}</div>
    </>
}